/* eslint-disable indent */
import React from 'react';

import './PriceUnit.scss';

const PriceUnit = ({
  type,
  extraClassName,
  component: Component = 'span',
  ...restOfProps
}) => {
  switch (type) {
    case 'HOUR':
    case 'FIRST_HOUR': {
      return (
        <Component
          className={`ui-price-unit ${extraClassName}`}
          {...restOfProps}
        >
          &nbsp;&#8381;/ч
        </Component>
      );
    }

    case 'METER':
    case 'FOR_METER': {
      return (
        <Component
          className={`ui-price-unit ${extraClassName}`}
          {...restOfProps}
        >
          &nbsp;&#8381;/м
        </Component>
      );
    }

    case 'METER_SQUARED':
      return (
        <Component
          className={`ui-price-unit ${extraClassName}`}
          {...restOfProps}
        >
          &nbsp;&#8381;/м²
        </Component>
      );

    case 'PURCHASE_PERCENT':
      return (
        <Component
          className={`ui-price-unit ${extraClassName}`}
          {...restOfProps}
        >
          &nbsp;%
        </Component>
      );

    default:
      return <>&nbsp;&#8381;</>;
  }
};

export default PriceUnit;
